import { DeleteOutlined } from "@mui/icons-material";
import AddSharpIcon from "@mui/icons-material/AddSharp";
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import ReplayIcon from '@mui/icons-material/Replay';
import StickyNote2Icon from "@mui/icons-material/StickyNote2";
import WarningIcon from '@mui/icons-material/Warning';
import { Tooltip } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import { Table } from 'react-bootstrap';
import { useLocation, useParams } from 'react-router';
import barrelListCheck from "../../assets/images/icons/BarrelListCheck.svg";
import EditIcon from '../../assets/images/icons/EditIcon.svg';
import Constant from '../../Constant';
import { CommonService } from '../../Service/CommonService';
import { InventoryApiService } from '../../Service/InventoryApiService';
import { OrderApiService } from '../../Service/OrderApiService';
import CustomSpinner from '../Common/CustomSpinner';
import StatusDropdown from "../Common/StatusDropdown";
import CurrencyFormatter from '../Static/CurrencyFormatter';
import BarrelSelectionPanel from './BarrelSelectionPanel';
import SameInventoryOrders from './SameInventoryOrders';
import ViewProductDetail from './ViewProductDetail';

interface CartProps {
    cartItems: any[];
    onEditClick: (itemId: string) => void;
    onDeleteRestoreClick: (itemId: string, activeStatus: boolean) => void;
    onOrderItemStatusChange:(newStatus: string, orderItemId: any, inventoryId: any, inventoryTitle: any) => void;
    viewDetails: any;
    handleViewClose: any;
    handleViewShow: any;
    isNotEnoughBarrels: any[];
    isNotSelectedRequiredBarrel: any[];
    clearArrays; // Receive the function to clear arrays,
    orderStatus: any;
}

const InventoryFileListTable: React.FC<CartProps> = ({ cartItems, onEditClick, onDeleteRestoreClick, onOrderItemStatusChange, viewDetails, handleViewClose, handleViewShow, isNotEnoughBarrels, isNotSelectedRequiredBarrel, clearArrays, orderStatus }) => {
    const location = useLocation();
    const currentPath = location.pathname;
    const { id } = useParams<{ id: string }>();
    const [isOpen, setIsOpen] = useState<boolean[]>();
    const [inventoryId, setinventoryId] = useState("");
    const [isCurrentStatusPendingOrUnderReview, setIsCurrentStatusPendingOrUnderReview] = useState<boolean>(false);
    const [isSeller, setIsSeller] = useState<boolean>(false);
    const [orderSummary, setOrderSummary] = React.useState<any>([]);
    const [isOrderItemStatusActionRequired, setIsOrderItemStatusActionRequired] = useState<boolean>(false);
    const [viewBarrelSelection, setViewBarrelSelection] = useState(false);
    const [totalAvailableBarrelsCount, setTotalAvailableBarrelsCount] = React.useState<any>([]);
    const [totalReservedBarrelsCount, setTotalReservedBarrelCount] = React.useState<any>([]);
    const [selectedOrderItem, setSelectedOrderItem] = useState<any>(null);
    const [selectedOrderItemIndex, setSelectedOrderItemIndex] = useState<number | null>(null);
    const [inventoryOrderStatus, setInventoryOrderStatus] = useState<{ [key: string]: boolean }>({});
    const [isSpinner, setIsSpinner] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);
    const [openRowIndex, setOpenRowIndex] = useState<number | null>(null);
    let dashboardPrefrence="";
    // For Setting Equal width 
    const priceRef = useRef<HTMLTableCellElement>(null);
    const totalPriceRef = useRef<HTMLTableCellElement>(null);
    const handlingRef = useRef<HTMLTableCellElement>(null);
    const servicesRef = useRef<HTMLTableCellElement>(null);
    const ownerStatusRef = useRef<HTMLTableCellElement>(null);
    const actionRef = useRef<HTMLTableCellElement>(null);
    const platformFeesRef = useRef<HTMLTableCellElement>(null);
    const finalPriceRef = useRef<HTMLTableCellElement>(null);
    const totalProceedsRef = useRef<HTMLTableCellElement>(null);
    

  const [columnWidths, setColumnWidths] = useState<{
    priceWidth: number;
    totalPriceWidth: number;
    handlingWidth: number;
    servicesWidth: number;
    ownerStatusWidth: number;
    actionWidth: number;
    platformFeesWidth: number;
    finalPriceWidth: number;
    totalProceedsWidth:number;
  }>({
    priceWidth: 0,
    totalPriceWidth: 0,
    handlingWidth: 0,
    servicesWidth: 0,
    ownerStatusWidth: 0,
    actionWidth: 0,
    platformFeesWidth: 0,
    finalPriceWidth:0,
    totalProceedsWidth:0,

  });

    useEffect(() => {
        const measureWidths = () => {
        setColumnWidths({
            priceWidth: priceRef.current?.offsetWidth || 0,
            totalPriceWidth: totalPriceRef.current?.offsetWidth || 0,
            handlingWidth: handlingRef.current?.offsetWidth || 0,
            servicesWidth: servicesRef.current?.offsetWidth || 0,
            ownerStatusWidth: ownerStatusRef.current?.offsetWidth || 0,
            actionWidth: actionRef.current?.offsetWidth || 0,
            platformFeesWidth: platformFeesRef.current?.offsetWidth || 0,
            finalPriceWidth: finalPriceRef.current?.offsetWidth || 0,
            totalProceedsWidth :totalProceedsRef.current?.offsetWidth || 0,
        });
        };

        // Use ResizeObserver to track size changes
        const resizeObserver = new ResizeObserver(() => {
        measureWidths();
        });

        // Observe each reference
        const refs = [
        priceRef,
        totalPriceRef,
        handlingRef,
        servicesRef,
        ownerStatusRef,
        actionRef,
        platformFeesRef,
        finalPriceRef,
        totalProceedsRef,
        ];

        refs.forEach((ref) => {
        if (ref.current) {
            resizeObserver.observe(ref.current);
        }
        });

        // Measure widths initially
        measureWidths();

        // Cleanup observer on unmount
        return () => {
        resizeObserver.disconnect();
        };
    }, []);

    const checkMultipleOrders = async (inventoryId: any, requestId:any) => {
        try {
          const response = await OrderApiService.inventoryHasMultipleOrders(inventoryId,requestId);
          setInventoryOrderStatus((prevState) => ({
            ...prevState,
            [inventoryId]: response.data, // Assuming API returns true/false
          }));
        } catch (error) {
          console.error("Error checking multiple orders:", error);
        }
      };

    const handleSideViewShow = () => {
        // Close same inventory toggle sections
        setOpenRowIndex(prevIndex => null);
        
        // Call handleViewShow() to perform additional actions
        handleViewShow();
    }
  

    useEffect(() => {
        setIsOpen(cartItems.map(() => false));

        const isSeller = cartItems.some((item) => {
            return item.inventoryOwnerCompanyId === CommonService.getCompanyId() && CommonService.isUser()
        });
        setIsSeller(isSeller);

        const currentStatus = cartItems.some((item) => {
            return item.orderStatus === "PENDING_REVIEW" || item.orderStatus === "UNDER_REVIEW";
        });
        setIsCurrentStatusPendingOrUnderReview(currentStatus);

        const orderItemStatus = cartItems.some((item) => {
            return !item.isOrderItemDeleted && item.ownerOrderStatus === "ACTION_REQUIRED" && (orderStatus === "PENDING_REVIEW" || orderStatus === "UNDER_REVIEW")
                && (CommonService.getRole() === Constant.Role.ADMIN && CommonService.isSameCompany(item?.companyId)
                    || CommonService.isSameUser(item.createdBy)
                ); 
        });
        setIsOrderItemStatusActionRequired(orderItemStatus);

        // Handle admin-specific data fetching
        const fetchBarrelCount = async () => {
            if (CommonService.isAdmin() || CommonService.isWarehouse()) {
                setIsSpinner(true);

                // Initialize state with 0s for each cart item
                setTotalAvailableBarrelsCount(new Array(cartItems.length).fill(0));
                setTotalReservedBarrelCount(new Array(cartItems.length).fill(0));

                // Wait for all fetches to complete before hiding the spinner
                const fetchPromises = cartItems.map(async (item, index) => {
                    // Fetch available container count for each item
                    fetchTotalAvailableBarrelCount(item?.inventoryId, index);

                    // Fetch reserved container count if the order is not in "PENDING_REVIEW" or "UNDER_REVIEW" status
                    const isNotReviewStatus = item?.orderStatus !== "PENDING_REVIEW" && item?.orderStatus !== "UNDER_REVIEW";
                    if (isNotReviewStatus) {
                        fetchTotalReservedBarrelCount(item?.orderId, item?.id, index);
                    }

                    //fetch inventory has multiple orders or not if role is super admin
                    if (CommonService.isAdmin()) {
                        checkMultipleOrders(item?.inventoryId, item?.id);
                    }
                });

                // Wait for all fetch promises to resolve
                await Promise.all(fetchPromises);

                // Set spinner to false after all async operations are done
                setIsSpinner(false);
            }
        };

        // Call the fetchData function
        fetchBarrelCount();
        fetchOrderSummaryDetail(); // Fetch updated order total details

        const handleClickOutside = () => {
            setOpenRowIndex(null); // Close when clicking anywhere outside
        };

        setOpenRowIndex(null);
        document.addEventListener("click", handleClickOutside);
        return () => {
          document.removeEventListener("click", handleClickOutside);
        };
    }, [cartItems]);

    const toggleSection = (index: number) => {
        setIsOpen(prevState => prevState.map((open, i) => (i === index ? !open : open)));
    };

    //formate the ownerOrderStatus
    function formatStatus(ownerOrderStatus?: string): string {
        let formattedStatus = "";
        if (ownerOrderStatus !== undefined) {
        formattedStatus = ownerOrderStatus
            ?.split(/[_\\]/)
            .map(
            (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
            )
            .join(" ");
        }
        return formattedStatus;
    }

    const changeOrderItemActiveStatus = async (itemId: string, activeStatus: boolean) => {
        setIsDeleting(true); 
        await onDeleteRestoreClick(itemId, activeStatus); // Wait for the API response
        setIsDeleting(false);
    };

    const fetchOrderSummaryDetail = async () => {

        if (currentPath.startsWith('/user/view-as-buyer/order-detail'))
          dashboardPrefrence = Constant.Profile.BUYER;
        else if (currentPath.startsWith('/user/view-as-owner/order-detail'))
          dashboardPrefrence = Constant.Profile.OWNER;
        else
          dashboardPrefrence= CommonService.getDashboardPrefrence();
    
        const response: any = await OrderApiService.getOrderSummaryByOrderId(id, dashboardPrefrence);
        if (response.data) setOrderSummary(response.data);
    };

    const handleShowBarrelSelection = (orderItem: any, index) => {
        setViewBarrelSelection(true);
        setSelectedOrderItem(orderItem);
        setSelectedOrderItemIndex(index);
    }
    
    const handleCloseBarrelSelection = () => {
        setViewBarrelSelection(false);
        clearArrays(); 
        fetchTotalAvailableBarrelCount(selectedOrderItem?.inventoryId, selectedOrderItemIndex);
        fetchTotalReservedBarrelCount(selectedOrderItem?.orderId, selectedOrderItem?.id, selectedOrderItemIndex);
    }

    // Fetches the total available barrel count for a given group
    const fetchTotalAvailableBarrelCount = async (inventoryId: string, index: number) => {
        try {
            setIsSpinner(true);
            const response = await InventoryApiService.getAllBarrelsCount(inventoryId);
            setTotalAvailableBarrelsCount((prevCounts: any[]) => {
                const newCounts = [...prevCounts];
                newCounts[index] = response?.data; // Update count for specific item index
                return newCounts;
            });
        } catch (error) {
            console.error('Error fetching available container count:', error);
        } finally {
            setIsSpinner(false);
        }
    };

    // Fetches the total reserved barrel count for a specific order item
    const fetchTotalReservedBarrelCount = async (orderId: any, orderItemId: any, index: number) => {
        try {
            setIsSpinner(true);
            const response = await OrderApiService.getOrderReservedBarrelsCount(orderId, orderItemId);
            setTotalReservedBarrelCount((prevCounts: any[]) => {
                const newCounts = [...prevCounts];
                newCounts[index] = response?.data; // Update count for specific item index
                return newCounts;
            });
        } catch (error) {
            console.error('Error fetching reserved container count:', error);
        } finally {
            setIsSpinner(false);
        }
    };


    const handleToggleSameInventory = (event: React.MouseEvent, index: number) => {
        event.stopPropagation(); // Prevent parent click event
        setOpenRowIndex(openRowIndex === index ? null : index);
      };

    return (
        <>
        <div className="table-responsive-lg table-responsive-fixed-header">
                <Table className='orderRequest-inv-table'>
                <thead>
                <tr>
                    <th className='text-nowrap text-start'>Inventory</th>
                    { !isSeller && <>
                    <th colSpan={2} className="text-center text-nowrap">Seller</th>
                    <th colSpan={2} className="text-center text-nowrap">Buyer</th>
                    </>}
                    <th className='text-nowrap'>Quantity</th>
                    <th  ref={priceRef} className='text-nowrap'>Sell Price</th>
                    {isSeller && <>
                    <th className='text-nowrap' ref={platformFeesRef}>Commission Fee</th>
                    {/* <th className='text-nowrap text-center' ref={platformFeesRef}>Total Fee</th> */}
                    <th ref={totalPriceRef} className='text-nowrap'>Proceeds</th>
                    <th ref={totalProceedsRef} className='text-nowrap'>Total Proceeds</th>
                    </>}
                    { !isSeller && <>
                    {/* <th colSpan={2} className="text-center text-nowrap">Fees</th> */}
                    <th className='text-nowrap' ref={finalPriceRef}>Final Price</th>
                    </>}

                    { (isSeller || CommonService.isAdmin()) && <th className='text-nowrap text-center' ref={ownerStatusRef}>Owner Status</th>}
                    {(isOrderItemStatusActionRequired || (CommonService.isAdmin() && isCurrentStatusPendingOrUnderReview)) && <th className='text-nowrap text-center' ref={actionRef}> Action</th> }
                </tr>
                <tr>
                    <th className='text-nowrap text-center'></th>
                    { !isSeller && <>
                    <th className='text-nowrap text-center'>Relocation</th>
                    <th className='text-nowrap text-center'>Cha. of Acc.</th>
                    <th className='text-nowrap text-center'>Relocation</th>
                    <th className='text-nowrap text-center'>Cha. of Acc.</th>
                    </>}
                    <th className='text-nowrap text-center'></th>
                    {isSeller && <>
                    <th className='text-nowrap text-center'></th>
                    {/* <th className='text-nowrap text-center'></th> */}
                    <th className='text-nowrap text-center'></th>
                    <th className='text-nowrap text-center'></th>
                    </>}
                    <th className='text-nowrap text-center'></th>
                    { !isSeller && <>
                    {/* <th className='text-nowrap' ref={handlingRef}>Handling</th>
                    <th className='text-nowrap' ref={servicesRef}>Service</th> */}
                    <th className='text-nowrap'></th> 
                    </>}
                    {(isSeller || CommonService.isAdmin()) && <th className='text-nowrap text-center'></th>}
                    {(isOrderItemStatusActionRequired || (CommonService.isAdmin() && isCurrentStatusPendingOrUnderReview)) &&<th className='text-nowrap text-center'></th>}
                </tr>
                </thead>
                {/* {(!cartItems || cartItems.length == 0) ? (
                  <div style={{ height: "236px", display: "flex", alignItems: "center", justifyContent: "center", textAlign: 'center' }}>
                    <CustomSpinner />
                  </div>
                ):(     */}
                <tbody>
                 
                    <>
                    { cartItems.length > 0 ? (
                        cartItems.map((item: any, index: number) => (
                            <React.Fragment key={index}>
                                <tr className={`${item?.isOrderItemDeleted ? "deleted-item-row" : (["REJECTED", "ADMIN_REJECTED"].includes(item?.ownerOrderStatus)) ? (CommonService.isAdmin() ? "rejected-item-row" : "rejected-item-row-buyer-owner") : ""}`}>
                                    <td className='text-start cursor-pointer' onClick={() => {handleSideViewShow(); setinventoryId(item.inventoryId); }}>
                                        <div className="header d-flex flex-column ms-1 position-relative" onClick={() => toggleSection(index)}>
                                            {/* <div className={`icon ${isOpen[index] ? 'minus' : 'plus'}`}></div> */}
                                            {/* <>
                                                {isOpen[index] ? <RemoveCircleOutlineIcon sx={{ color: "#737376", mr: 1, cursor: 'pointer' }} /> : <AddCircleOutlineIcon sx={{ color: "#737376", mr: 1, cursor: 'pointer' }} />}
                                            </> */}
                                            <span className="inventory-name text-nowrap">{item.inventoryTitle} 
                                            {CommonService.isAdmin() && !item?.isOrderItemDeleted && !["REJECTED", "OWNERSHIP_TRANSFERRED","CLOSED", "CANCELLED","IN_TRANSIT"].includes(item?.orderStatus) && inventoryOrderStatus[item.inventoryId] && (<span className='image-wrapper ms-2' onClick={(event) => handleToggleSameInventory(event, index)}>
                                                    <img src={barrelListCheck} alt="barrel-list"></img>
                                                </span>)}
                                            </span>
                                            {CommonService.isAdmin() && <span className="company-name">{item.inventoryOwnerCompanyName}</span>}

                                        <span className='removed-text'>Removed</span>
                                        {openRowIndex === index && (
                                        <div className='position-absolute bottom-0 top-100 start-50' style={{ zIndex: 20 }} onClick={(event) => event.stopPropagation()}>
                                            <SameInventoryOrders inventoryId={item?.inventoryId} requestId={item?.id} />
                                            </div>
                                        )}
                                        </div>
                                    </td>
                                    { !isSeller && <>
                                    <td className='text-center'>
                                        {item.isRelocationRequiredByOwner ? (
                                            <>
                                                <CheckIcon fontSize="small" sx={{ color: '#25CD25' }} /> Yes
                                            </>
                                        ) : (
                                            <>
                                                <CloseIcon fontSize="small" sx={{ color: '#FF3B30' }} /> No
                                            </>
                                        )}
                                    </td>
                                    <td className='text-center'>
                                        {item.isAccountTransferByOwner ? (
                                            <>
                                               <CheckIcon fontSize="small" sx={{ color: '#25CD25' }} /> Yes
                                           </>
                                        ) : (
                                           <>
                                               <CloseIcon fontSize="small" sx={{ color: '#FF3B30' }} /> No
                                           </>
                                        )}
                                    </td>
                                    <td className='text-center'>
                                        {item.isRelocationRequiredByBuyer ? (
                                            <>
                                                <CheckIcon fontSize="small" sx={{ color: '#25CD25' }} /> Yes
                                            </>
                                        ) : (
                                            <>
                                                <CloseIcon fontSize="small" sx={{ color: '#FF3B30' }} /> No
                                            </>
                                        )}
                                    </td>
                                    <td className='text-center'>
                                        {item.isAccountTransferByBuyer ? (
                                            <>
                                               <CheckIcon fontSize="small" sx={{ color: '#25CD25' }} /> Yes
                                           </>
                                        ) : (
                                           <>
                                               <CloseIcon fontSize="small" sx={{ color: '#FF3B30' }} /> No
                                           </>
                                        )}
                                    </td>
                                    </>}
                                    {(item?.isOrderItemDeleted || ["REJECTED", "ADMIN_REJECTED"].includes(item?.ownerOrderStatus)) && <td className='pb-4'>{item.quantity} container</td>}
                                    {(!item?.isOrderItemDeleted && !["REJECTED", "ADMIN_REJECTED"].includes(item?.ownerOrderStatus)) && (
                                        <td className={`${!(totalAvailableBarrelsCount[index] < item?.quantity) && "pb-4"}`}>
                                            <div className="position-relative text-nowrap">
                                                {item?.quantity} container
                                                <>
                                                    {CommonService.isAdmin() && !isSpinner && !['REJECTED', 'CANCELLED', 'CLOSED', 'IN_TRANSIT', 'OWNERSHIP_TRANSFERRED'].includes(item?.orderStatus) && (
                                                        <Tooltip
                                                            arrow
                                                            title={`${Intl.NumberFormat().format(totalAvailableBarrelsCount[index] + totalReservedBarrelsCount[index])} ${(totalAvailableBarrelsCount[index] + totalReservedBarrelsCount[index]) > 1 ? 'Containers' : 'Container'} in Stock`}
                                                        >
                                                            <span
                                                                className="available-barrels-count ms-2"
                                                                style={{
                                                                    backgroundColor: (totalAvailableBarrelsCount[index] + totalReservedBarrelsCount[index]) < item?.quantity && totalReservedBarrelsCount[index] !== item?.quantity ? "#BE6038" : "#469473"
                                                                }}
                                                            >
                                                                {(totalAvailableBarrelsCount[index] + totalReservedBarrelsCount[index]) >= 10000 ? "9,999+" : Intl.NumberFormat().format(totalAvailableBarrelsCount[index] + totalReservedBarrelsCount[index])}
                                                            </span>
                                                        </Tooltip>
                                                    )}

                                                    {(CommonService.isAdmin() || CommonService.isWarehouse()) && !isSpinner && !['REJECTED', 'CANCELLED', 'PENDING_REVIEW', 'UNDER_REVIEW'].includes(item?.orderStatus) && (
                                                        <div>
                                                            <>
                                                                {totalAvailableBarrelsCount[index] >= item?.quantity && totalReservedBarrelsCount[index] === 0 && (
                                                                    <button
                                                                        style={{ marginLeft: "-4px" }}
                                                                        onClick={() => handleShowBarrelSelection(item, index)}
                                                                        className="reserve-barrel-btn ps-0 text-nowrap"
                                                                    >
                                                                        <AddSharpIcon /> Reserve
                                                                    </button>
                                                                )}

                                                                {totalReservedBarrelsCount[index] > 0 && (
                                                                    <button
                                                                        onClick={() => handleShowBarrelSelection(item, index)}
                                                                        className="reserve-barrel-btn ps-0 text-nowrap"
                                                                    >
                                                                        {totalReservedBarrelsCount[index]} Reserved
                                                                    </button>
                                                                )}
                                                            </>
                                                        </div>
                                                    )}

                                                    {(totalAvailableBarrelsCount[index] + totalReservedBarrelsCount[index]) < item?.quantity && !isSpinner && isNotEnoughBarrels.includes(item?.id) && (CommonService.isAdmin() || CommonService.isWarehouse()) && (
                                                        <span
                                                            className="barrel-error"
                                                            style={{
                                                                bottom: (totalAvailableBarrelsCount[index] > 0 && isNotEnoughBarrels.includes(item?.id)) ? "-40px" : "-35px"
                                                            }}
                                                        >
                                                            <WarningIcon /> Out of Stock, please change quantity.
                                                        </span>
                                                    )}

                                                    {(totalAvailableBarrelsCount[index] < item?.quantity || totalReservedBarrelsCount[index] < item?.quantity) && isNotSelectedRequiredBarrel.includes(item?.id) && !isSpinner && (CommonService.isAdmin() || CommonService.isWarehouse()) && (
                                                        <span
                                                            className="barrel-error"
                                                            style={{
                                                                bottom: totalAvailableBarrelsCount[index] > 0 ? "-22px" : "-35px"
                                                            }}
                                                        >
                                                            <WarningIcon />Please select a number of items equal to the specified quantity.
                                                        </span>
                                                    )}
                                                </>
                                            </div>
                                        </td>
                                    )}

                                    <td  ref={priceRef} className='price-text' style={{minWidth: 105}}><CurrencyFormatter amount={item.price} locale="en-US" currency="USD" />
                                    <p className="per-barrel-text">per container</p></td>
                                    {isSeller && <>
                                    <td className=' price-text' ref={platformFeesRef}>
                                        (<CurrencyFormatter
                                            amount={
                                            item.feeType == 'FLAT' 
                                                ? item.platformFee
                                                : item.price - item.price / (1 + item.platformFee / 100)
                                            }
                                            locale="en-US"
                                            currency="USD"
                                        />)
                                        <p className="per-barrel-text">per container</p>
                                    </td>
                                    {/* <td className='text-center' ref={platformFeesRef}>
                                        (<CurrencyFormatter
                                            amount={
                                            item.feeType == 'FLAT' 
                                                ? item.platformFee * item.quantity
                                                : (item.price * item.platformFee) / 100
                                            }
                                            locale="en-US"
                                            currency="USD"
                                        />)
                                    </td> */}
                                    </>}
                                    {isSeller && <>
                                    <td  ref={priceRef} className='price-text'><CurrencyFormatter amount={ 
                                        item.feeType == 'FLAT' 
                                        ? item.price - item.platformFee
                                        : item.price / (1 + item.platformFee / 100)} locale="en-US" currency="USD" />
                                        <p className="per-barrel-text">per container</p>
                                    </td>
                                    <td ref={totalPriceRef} className='price-text'><CurrencyFormatter amount={
                                        item.feeType == 'FLAT' 
                                        ? (item.totalPrice  - (item.platformFee * item.quantity))
                                        : (item.totalPrice / (1 + item.platformFee / 100))} locale="en-US" currency="USD" /></td>
                                    </>}
                                    { !isSeller && <>
                                    {/* <td ref={handlingRef} className='price-text'style={{width: 90}}><CurrencyFormatter amount={item.handlingFee/item?.quantity} locale="en-US" currency="USD" />
                                    <p className="per-barrel-text">per container</p></td>
                                    <td ref={servicesRef} className='price-text' style={{width: 90}}><CurrencyFormatter amount={item.serviceFee/item?.quantity} locale="en-US" currency="USD" />
                                    <p className="per-barrel-text">per container</p></td> */}
                                    <td ref={finalPriceRef} className='price-text'><CurrencyFormatter amount={(item.totalPrice) +
                                        item.handlingFee + item.serviceFee} locale="en-US" currency="USD" />
                                    </td>
                                    </>}
                                    {(isSeller || CommonService.isAdmin())  && <> 
                                    <td className='text-center' ref={ownerStatusRef}>
                                        {CommonService.isAdmin() && <StatusDropdown currentStatus={formatStatus(item?.ownerOrderStatus)}
                                            onStatusChange={(newStatus) =>
                                                onOrderItemStatusChange(newStatus,item['id'],item['inventoryId'],item['inventoryTitle'])
                                            }
                                            disableCondition={item?.isOrderItemDeleted || CommonService.isSameCompany(item?.companyId) || ["REJECTED", "ADMIN_REJECTED", "ACCEPTED"].includes(item?.ownerOrderStatus)
                                                || ["ACCEPTED", "REJECTED", "IN_PROGRESS", "CONTRACT_SENT", "CONTRACT_EXECUTED", "INVOICE_SENT", "PAYMENT_RECEIVED", "OWNERSHIP_TRANSFERRED", "IN_TRANSIT", "CLOSED", "CANCELLED"].includes(item?.orderStatus)
                                            }
                                            allowedLabels={(item?.ownerOrderStatus === "ADMIN_ACCEPTED") ? ["Reject for Owner"] 
                                                            : item?.ownerOrderStatus === "PENDING_REVIEW" ? ["Accept for Owner", "Reject for Owner"] 
                                                            :["Send to Owner", "Accept for Owner", "Reject for Owner"]}/>}

                                        {CommonService.isUser() && <StatusDropdown currentStatus={formatStatus(item?.ownerOrderStatus)}
                                            onStatusChange={(newStatus) =>
                                                onOrderItemStatusChange(newStatus,item['id'],item['inventoryId'],item['inventoryTitle'])
                                            }
                                            disableCondition={item?.isOrderItemDeleted || CommonService.isSameCompany(item?.companyId) || ["REJECTED", "ADMIN_REJECTED"].includes(item?.ownerOrderStatus)
                                                || ["ACCEPTED", "REJECTED", "IN_PROGRESS", "CONTRACT_SENT", "CONTRACT_EXECUTED", "INVOICE_SENT", "PAYMENT_RECEIVED", "OWNERSHIP_TRANSFERRED", "IN_TRANSIT", "CLOSED", "CANCELLED"].includes(item?.orderStatus)
                                            }
                                            allowedLabels={item?.ownerOrderStatus === "ADMIN_ACCEPTED" ? ["Rejected"] : ["Accepted", "Rejected"]}/>}

                                        {(item?.ownerOrderStatus === "REJECTED" || item?.ownerOrderStatus === "ADMIN_REJECTED") && (
                                            <Tooltip
                                            title={`Rejection Note: ${item.ownerOrderRejectionNote}`}
                                            arrow
                                            >
                                            <StickyNote2Icon
                                                className="note-icon cursor-pointer"
                                                style={{ color: "gray" }}
                                            />
                                            </Tooltip>
                                        )}

                                    </td></>}
                                    {((((CommonService.isSameCompany(item?.companyId) && CommonService.getRole() === Constant.Role.ADMIN) 
                                        || CommonService.isSameUser(item?.createdBy)) 
                                        && item?.ownerOrderStatus ===  "ACTION_REQUIRED" && (orderStatus === "PENDING_REVIEW" || orderStatus === "UNDER_REVIEW")) 
                                        || (CommonService.isAdmin() && isCurrentStatusPendingOrUnderReview))
                                        && <td className='text-center' ref={actionRef}>
                                                <div className='d-flex justify-content-center gap-3'>
                                                    {!item?.isOrderItemDeleted && <img
                                                        src={EditIcon}
                                                        alt="EditIcon"
                                                        onClick={() => onEditClick(item.id)} 
                                                        style={{ cursor: 'pointer' }}
                                                    />}
                                                    {cartItems.filter(item => !item.isOrderItemDeleted).length > 1 && !item?.isOrderItemDeleted &&
                                                        (<button style={{ background: "none", border: "none", cursor: isDeleting ? "not-allowed" : "pointer", opacity: isDeleting ? 0.5 : 1 }}
                                                            onClick={() => changeOrderItemActiveStatus(item?.id, true)} disabled={isDeleting}>
                                                            <DeleteOutlined />
                                                        </button>
                                                    )}
                                                    {item?.isOrderItemDeleted && <button style={{ background: "none", border: "none" }} 
                                                        onClick={() => changeOrderItemActiveStatus(item?.id, false)} disabled={isDeleting}>
                                                        <ReplayIcon sx={{ transform: "rotate(-45deg)", fill: "#333333" }} />
                                                    </button>}
                                                </div>
                                        </td>
                                    }
                                </tr>
                            </React.Fragment>
                        ))
                    ):(
                        <tr>
                        <td colSpan={12} style={{ textAlign: 'center' }} className='border-0'>
                          <div style={{ height: "222px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                            <CustomSpinner />
                          </div>
                        </td>
                      </tr>  
                    )}
                    </>
                </tbody>
            </Table>
            
        </div>
        {cartItems.length > 0 && (<div className='total-row--wrapper'>
            <div className="d-flex justify-content-end flex-wrap">
                    <div className='d-flex align-items-start'>
                        <div className='total--amount-wrapper' style={{ width: `${columnWidths.priceWidth}px`,whiteSpace:"nowrap",minWidth:isSeller ? "150px":"" }}>
                            {isSeller ? 'Final Proceeds:' : 'Total:'}
                        </div>
                        {isSeller && <div className='amount-wrapper' style={{ width: `${columnWidths.totalProceedsWidth}px`, minWidth: 100, }}>
                            {/* {isSeller && (<CurrencyFormatter
                                amount={(orderSummary.totalPlatformFees)}
                                locale="en-US"
                                currency="USD"
                            />)} */}
                             <div className='mb-0'>
                                <div>
                                    <CurrencyFormatter
                                        amount={orderSummary.orderTotalWithoutPlatformFees}
                                        locale="en-US"
                                        currency="USD"
                                    />
                                </div>
                                <div className='total--amount-wrapper position-relative p-0'>
                                    <p className='shipping-info m-0'>Price includes all service and handling fees, shipping fees not included.</p>
                                </div>
                            </div>
                        </div>}
                        {/* {isSeller && (<>
                        <div className='amount-wrapper' style={{ width: `${isSeller ? columnWidths.platformFeesWidth : columnWidths.totalPriceWidth}px`, minWidth: 100, }}>
                            (<CurrencyFormatter
                                amount={(orderSummary.platformFees)}
                                locale="en-US"
                                currency="USD"
                            />)
                        </div>
                        <div className='amount-wrapper' style={{ width: `${isSeller ? columnWidths.platformFeesWidth : columnWidths.totalPriceWidth}px`, minWidth: 100, }}>
                        (<CurrencyFormatter
                            amount={(orderSummary.totalPlatformFees)}
                            locale="en-US"
                            currency="USD"
                        />)
                        </div>
                        </>)} */}
                        {/* {!isSeller && <>
                            <div className='amount-wrapper' style={{ width: `${columnWidths.handlingWidth}px` }}>
                                <CurrencyFormatter
                                    amount={orderSummary.totalHandlingFees}
                                    locale="en-US"
                                    currency="USD"
                                />
                            </div>
                            <div className='amount-wrapper' style={{ width: `${columnWidths.servicesWidth}px` }}>
                                <CurrencyFormatter
                                    amount={orderSummary.totalServiceFees}
                                    locale="en-US"
                                    currency="USD"
                                />
                            </div>
                        </>} */}
                    </div>
                <div className="total--amount-wrapper pb-4" style={{ width: `${columnWidths.ownerStatusWidth + columnWidths.actionWidth + columnWidths.finalPriceWidth}px`, minWidth:(!CommonService.isAdmin() && !isSeller)?  "105px" :"180px" }}>
                    {!isSeller && (<>
                        <div style={{ width: (!isSeller && !CommonService.isAdmin ) && (`${columnWidths.servicesWidth}px` )}} className='position-relative ms-2'>
                                <CurrencyFormatter
                                    amount={!isSeller ? orderSummary.orderTotal : orderSummary.orderTotalWithoutPlatformFees}
                                    locale="en-US"
                                    currency="USD"
                                />
                                <p className='shipping-info m-0'>Price includes all service and handling fees, shipping fees not included.</p>
                        </div> 
                    </>)}
                </div>
            </div>
        </div>)}
        {viewDetails &&
            <ViewProductDetail handleViewClose={handleViewClose} inventoryId={inventoryId} />
        }
        {viewBarrelSelection && <BarrelSelectionPanel 
                                    requestType={Constant.RequestType.ORDER_REQUEST} 
                                    requestId={id}
                                    orderItemId={selectedOrderItem?.id}
                                    inventoryId={selectedOrderItem?.inventoryId} 
                                    inventoryName={selectedOrderItem?.inventoryName} 
                                    requiredQuantity={selectedOrderItem?.quantity} 
                                    companyName={selectedOrderItem?.inventoryOwnerCompanyName} 
                                    currentStatus={selectedOrderItem?.orderStatus} 
                                    handleCloseBarrelSelection={handleCloseBarrelSelection} />}
        </>
    );
};

export default InventoryFileListTable;